export default function ChromePointerCircle() {
  return (
    <div
      style={{
        width: '12px',
        height: '12px',
        'border-radius': '6px',
        'box-shadow': 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)',
      }}
    />
  )
}
